import { render } from "./HowToRequestMilitaryMedals.vue?vue&type=template&id=7822690a"
import script from "./HowToRequestMilitaryMedals.vue?vue&type=script&lang=ts"
export * from "./HowToRequestMilitaryMedals.vue?vue&type=script&lang=ts"
script.render = render

export default script